import React, { useContext, useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import "../../styles/team.pc.css";
import "../../styles/table.pc.css";
import "../Team/Team.css";
import Search from "../../UiLib/Search/Search";
import BtnAdd from "../../buttons/btnAdd.component/BtnAdd";
import "../../../globalStyles/dataTableStyles.css";
import { Context } from "../../../index";
import { useParams } from "react-router-dom";
import PersonLineDisplay from "../../Shared/PersonLineDisplay";
import BtnDelete from "../../buttons/btnDelete.component/BtnDelete";
import Checkbox from "../../Shared/Checkbox/Checkbox";
import { ProjectContext } from "../../../pages/Project/Project";
import ConfirmationWindow from "../../Shared/ConfirmationWindow/ConfirmationWindow";
import { fullNameFormat } from "../../../helpers/Inicials";
import ProjectAddPersonRole from "../ProjectAddPersonRole/ProjectAddPersonRole";
import { IExcludePermissionFunction } from "../../../models/PermissionModels/IExcludePermissionFunction";
import EditIconBlue from "../../../assets/edit.svg";
import EditIconGray from "../../../assets/editButtonGray.svg";

import ProjectEditRoleBoard from "../ProjectEditRoleBoard/ProjectEditRoleBoard";
import { AppContext } from "../../../App";
// import { IFunctionPermissions } from "../../../common/api_interfaces/role/FunctionsAccessResponse";
import { IFunctionPermissions } from "../../../common/api_interfaces/role/IFunctionPermissions";
import UserPopupWrapper from "../../Shared/UserPopup/UserPopupWrapper";
import FilterContainer from "../../Shared/Filter/FilterContainer";
import { hasPermission } from "../../../helpers/hasPermisson";
import axios from "axios";
import { ITeamMemberDisplay } from "../../../common/api_interfaces/project/ITeamDisplay";
import { IAddTeamDisplay } from "../../../common/api_interfaces/project/IAddTeamMembers";
import { IDeleteTeamDisplay } from "../../../common/api_interfaces/project/IDeleteTeamMembers";

interface Item {
    name: string;
    code: string;
    status?: string;
}

interface ItemPersonRole {
    name: string;
    code: string;
    personRoleId: number;
}

interface ItemTeam {
    name: string;
    code: string;
    status?: string;
}

export interface ITeamFilter {
    projectId: number;
    role: number[] | undefined;
    name: string | undefined;
}

interface ITeamProps {
    members: ITeamMemberDisplay[];
    scrollEnded: boolean;
    updateFilters: () => void;
    loadTeamMembers: () => void;
    userAccess: IFunctionPermissions[];
}

const Team: React.FC<ITeamProps> = ({ members, scrollEnded, updateFilters, loadTeamMembers, userAccess }) => {
    const {
        persons,
        roles,
        filterOptionsTeam,
        applyFiltersTeam,
        counterTeam,
        setCounterTeam,
        selectedOptionsTeam,
        setSelectedOptionsTeam,
        setPageTeam,
        setScrollEndedTeam,
        teamSearchText,
        setTeamSearchText,
    } = useContext(ProjectContext);
    const { store } = useContext(Context);
    const { id } = useParams();
    const { showToast } = useContext(AppContext);
    const [value, setValue] = useState();
    const [openInput, setOpenInput] = useState(false);
    const [selectedUser, setSelectedUser] = useState<ItemPersonRole | null>(null);
    const [selectedRole, setSelectedRole] = useState<Item | null>(null);
    const [selectedMemberIds, setSelectedMemberIds] = useState<
        { personId: number; roleId: number; personRoleId: number }[]
    >([]);
    const [openConfirmWindow, setOpenConfirmWindow] = useState(false);
    const [openEditModal, setOpenEditModal] = useState<boolean>(false);
    const [roleEdit, setRoleEdit] = useState<IExcludePermissionFunction | undefined>();
    const curRef = useRef(null);
    const [openAddWindow, setOpenAddWindow] = useState(false);
    const [modeCreateP, setModeCreateP] = useState(false);
    const [prevAddPerson, setPrevAddPerson] = useState(false);

    // Ограничение прав
    const [viewTeam, setViewTeam] = useState(false);
    const [editPerson, setEditPerson] = useState(false);
    const [delPerson, setDelPerson] = useState(false);
    const [addPerson, setAddPerson] = useState(false);

    useEffect(() => {
        const keyDownHandler = (event: any) => {
            if (event.key === "Escape") {
                event.preventDefault();
                setOpenInput(false);
                onCancelClick();
            }
        };
        setAddPerson(hasPermission(userAccess, "ProjectTeamAction", "create"));
        setDelPerson(hasPermission(userAccess, "ProjectTeamAction", "delete"));
        setViewTeam(hasPermission(userAccess, "ProjectTeamAction", "view"));
        setEditPerson(hasPermission(userAccess, "ProjectTeamAction", "edit"));

        document.addEventListener("keydown", keyDownHandler);
        // Clean up event listener
        return () => {
            document.removeEventListener("keydown", keyDownHandler);
        };
    }, [userAccess]);

    useEffect(() => {
        store.setDeletePersons(true);
        setSelectedMemberIds([]);
    }, [id]);

    const personRowDisplay = (rowData: ITeamMemberDisplay) => {
        return (
            <UserPopupWrapper userId={rowData.id}>
                <PersonLineDisplay name={fullNameFormat(rowData, "s N M")} userId={rowData.id} />
            </UserPopupWrapper>
        );
    };

    function onSearchSubmit() {
        (curRef.current as any).scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        (async () => {
            await updateFilters();
        })();
    }

    function onAddClick() {
        // setOpenInput(!openInput);
        if (addPerson) {
            setOpenAddWindow(true);
        } else {
            showToast("У вас нет прав для добавления пользователя в проект!");
        }
    }

    function onCloseModal() {
        // setOpenInput(!openInput);
        setRoleEdit(undefined);
        setOpenAddWindow(false);
        setModeCreateP(false);
        clearChecks();
    }

    function onCancelClick() {
        (curRef.current as any).scrollTo({
            top: 0,
            left: 0,
        });
        setTeamSearchText("");
        setSelectedOptionsTeam({});
        setPageTeam(1);
    }

    useEffect(() => {
        if (teamSearchText.length === 0 && Object.keys(selectedOptionsTeam).length === 0) {
            (async () => {
                await loadTeamMembers(); //скиптейк вообще не используется )))))))))))))))))))
            })();
        }
    }, [teamSearchText, selectedOptionsTeam]);

    //https://ph.bpmlab.ru/T6667 для этого
    function clearChecks() {
        const checkboxes = document.querySelectorAll(".team_checkbox");
        checkboxes.forEach((checkbox) => {
            let chb = (checkbox as any).querySelector('input[type="checkbox"]');
            if (chb) {
                chb.checked = false;
            }
        });
    }

    const saveUserOnTeam = (e: any) => {
        e.preventDefault();

        if (selectedUser && selectedRole) {
            const body: IAddTeamDisplay = {
                projectId: Number(id),
                team: [
                    {
                        personId: Number(selectedUser.code),
                        roleId: Number(selectedRole.code),
                    },
                ],
            };

            (async () => {
                try {
                    const response = await store.teamService.addTeamMembers(body);
                    const users = response.data;
                    const data = await store.getDataToExcludePermissions(Number(selectedUser.code));
                    if (data) {
                        setRoleEdit(data);

                        setOpenInput(false);
                        loadTeamMembers();

                        setOpenAddWindow(false);
                        openEditWindow();
                    }
                } catch (error: any) {
                    if (axios.isAxiosError(error)) {
                        showToast(error.response?.data?.message, error.response?.data?.details);
                    }
                }
            })();

            setScrollEndedTeam(false);
            (curRef.current as any).scrollTo({
                top: 0,
                left: 0,
            });
            setPageTeam(1);
            setPrevAddPerson(true);
        }

        clearChecks();
    };

    useEffect(() => {
        if (store.deletePersons === true) {
            store.setDeletePersons(false);
            return;
        } else {
            let check = members?.find((xx) => xx.roleId === Number(selectedRole?.code));
            let personId = members.find((member) => member.id === Number(selectedUser?.code));
            if (personId) {
                let user: ItemPersonRole = {
                    name: fullNameFormat(personId, "s N M"),
                    code: String(personId.id),
                    personRoleId: personId.personRoleId,
                };
                setSelectedUser(user);
            }
            if (check && prevAddPerson) {
                let ids: { personId: number; roleId: number; personRoleId: number } = {
                    personId: check.id,
                    roleId: check.roleId,
                    personRoleId: check.personRoleId,
                };
                setSelectedMemberIds([ids]);
                openEditWindow();
                setOpenEditModal(true);
                setSelectedMemberIds([]);
                setPrevAddPerson(false);
            }
        }
    }, [members]);

    const handleTeamSelection = (memberId: number, event: any, nameForFilter?: string, roleId?: number) => {
        let ids = selectedMemberIds;

        if (event.target.checked && roleId) {
            let member = members.find((member) => member.roleId === roleId && member.id === memberId);
            if (member) {
                ids.push({ personId: member.id, roleId: member.roleId, personRoleId: member.personRoleId });
            }
        } else {
            ids = ids.filter((xx) => xx.personId !== memberId);
        }
        setSelectedMemberIds([...ids]);
    };

    function openEditWindow() {
        if (editPerson) {
            (async () => {
                let personId = selectedMemberIds.find((xx) => xx.personId);
                if (personId) {
                    const data = await store.getDataToExcludePermissions(personId.personId);
                    const member = members.find((member) => member.id === personId?.personId);

                    if (data && member) {
                        setRoleEdit(data);
                        setOpenEditModal(true);
                        let user: ItemPersonRole = {
                            name: fullNameFormat(member, "s N M"),
                            code: String(personId.personId),
                            personRoleId: personId.personRoleId,
                        };
                        setSelectedUser(user);
                    }
                }
            })();
        } else {
            showToast("У вас нет прав для редактирования пользователя!");
        }
    }

    function closeEditWindow() {
        setOpenEditModal(false);
    }

    function onDelete() {
        let body: IDeleteTeamDisplay = {
            projectId: Number(id),
            personRoleIds: selectedMemberIds.map((member) => member.personRoleId),
        };

        if (selectedMemberIds?.length) {
            (async () => {
                try {
                    await store.teamService.deleteTeamMembers(body);
                    loadTeamMembers();

                    setSelectedMemberIds([]);
                    setScrollEndedTeam(false);
                    (curRef.current as any).scrollTo({
                        top: 0,
                        left: 0,
                    });
                    setPageTeam(1);
                } catch (error: any) {
                    if (axios.isAxiosError(error)) {
                        const message = error.response?.data.message;
                        alert(message);
                    }
                }
            })();
        }

        setSelectedMemberIds([]);
        clearChecks();
    }

    const onConfirm = () => {
        store.setDeletePersons(true);
        onDelete();
        setOpenConfirmWindow(false);
    };
    const onCancel = () => {
        setOpenConfirmWindow(false);
    };

    const openConfWindow = () => {
        if (delPerson) {
            setOpenConfirmWindow(true);
        } else {
            showToast("У вас нет прав для удаления пользователя(ей)!");
        }
    };

    return (
        <div id="main-team-widget" className="widget_wrapper">
            {openEditModal ? (
                <div className="widget_wrapper--modal__edit">
                    <div className="widget_wrapper--modal__edit--size">
                        <ProjectEditRoleBoard
                            personRole={selectedUser}
                            closeFunc={closeEditWindow}
                            roleEdit={roleEdit}
                            projectId={Number(id)}
                        />
                    </div>
                </div>
            ) : null}
            {openAddWindow ? (
                <div>
                    <ProjectAddPersonRole
                        value={value}
                        setValue={setValue}
                        open={openInput}
                        personId={selectedUser}
                        save={saveUserOnTeam}
                        typeInput="list"
                        selectedUser={selectedUser}
                        setSelectedUser={setSelectedUser}
                        selectedRole={selectedRole}
                        setSelectedRole={setSelectedRole}
                        persons={persons}
                        roles={roles}
                        closeFunc={onCloseModal}
                        roleEdit={roleEdit}
                        projectId={Number(id)}
                        modeCreateP={modeCreateP}
                        members={members}
                    />
                </div>
            ) : null}
            {openConfirmWindow &&
                (selectedMemberIds?.length === 1 ? (
                    <ConfirmationWindow
                        headerText="Удаление сотрудника из команды"
                        bodyText="Вы уверены, что хотите удалить сотрудника?"
                        confirmText="Да"
                        cancelText="Нет"
                        onConfirm={onConfirm}
                        onCancel={onCancel}
                    />
                ) : (
                    <ConfirmationWindow
                        headerText="Удаление сотрудников из команды"
                        bodyText="Вы уверены, что хотите удалить сотрудников?"
                        confirmText="Да"
                        cancelText="Нет"
                        onConfirm={onConfirm}
                        onCancel={onCancel}
                    />
                ))}
            <div className="widgets_header">
                <div className="widgets_header--name__users">
                    <h2 className="widget-card-header-style" style={{ textWrap: "nowrap" }}>
                        Команда
                    </h2>
                </div>
                <div className="widjets_header_rigth">
                    <Search
                        onSubmitFunc={onSearchSubmit}
                        value={teamSearchText}
                        changeSearchValue={setTeamSearchText}
                    />
                    <FilterContainer
                        filterCounter={counterTeam}
                        setFilterCounter={setCounterTeam}
                        selectedOptions={selectedOptionsTeam}
                        setSelectedOptions={setSelectedOptionsTeam}
                        filterOptions={filterOptionsTeam}
                        showResetButton={teamSearchText.length > 0}
                        onReset={onCancelClick}
                        showApplyButton={true}
                        onApply={() => applyFiltersTeam()}
                    />
                    {selectedMemberIds?.length !== 0 && (
                        <BtnDelete onClickFunc={openConfWindow} permission={delPerson} />
                    )}
                    {selectedMemberIds?.length === 1 && (
                        <button className="widjets_header_rigth--edit" onClick={openEditWindow}>
                            <img src={editPerson ? EditIconBlue : EditIconGray} />
                        </button>
                    )}
                    <BtnAdd type={""} onClickFunc={onAddClick} permission={addPerson} />
                </div>
            </div>
            <div ref={curRef} className="custom_table">
                <table>
                    <tbody>
                        {viewTeam && members && members.length
                            ? members.map((member) => (
                                  <tr key={`member-${member.id}-${member.roleId}`}>
                                      <td className="team_checkbox">
                                          <Checkbox
                                              id={member.id}
                                              roleId={member.roleId}
                                              handleSelection={handleTeamSelection}
                                          />
                                          {personRowDisplay(member)}
                                      </td>
                                      <td>{member.roleName}</td>
                                  </tr>
                              ))
                            : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default observer(Team);
